<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M.06.06h19.88v19.88H.06V.06z" />
    <path
      d="M2.544 5.03l2.488 14.91h9.94l2.484-14.908H2.544v-.001zm15.74-3.313v1.657H1.716V1.717h4.73c.747 0 1.351-.91 1.351-1.657h4.404c0 .746.605 1.657 1.351 1.657h4.73z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
